import React from 'react';
import { motion } from 'framer-motion';
import { KeyIcon, ShieldIcon, UsbIcon, HardDriveIcon, LockIcon } from 'lucide-react';
export function BrandsSection() {
  const brands = [{
    name: 'OneKey',
    icon: KeyIcon,
    color: 'from-blue-500 to-blue-600',
    description: 'Hardware Wallets',
    customLogo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/51xQZ288UvQUDVXSjQX9Rx/onekey_icon_solid_green_black.svg'
  }, {
    name: 'YubiKey',
    icon: ShieldIcon,
    color: 'from-green-500 to-green-600',
    description: 'Authentication'
  }, {
    name: 'Faraday Bags',
    icon: ShieldIcon,
    color: 'from-purple-500 to-purple-600',
    description: 'Signal Blocking'
  }, {
    name: 'USB Blockers',
    icon: UsbIcon,
    color: 'from-orange-500 to-orange-600',
    description: 'Data Protection'
  }, {
    name: 'Encrypted Drives',
    icon: HardDriveIcon,
    color: 'from-indigo-500 to-indigo-600',
    description: 'Secure Storage'
  }];
  return <section id="brands" className="py-20 px-6 relative overflow-hidden" data-id="element-37">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-38" />
      {/* Brand Logos Background */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/5tPJUPgjkXPjE6iUNHibD6/Gemini_Generated_Image_sga8fdsga8fdsga8.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-39" />
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-41">
          <h2 className="text-4xl font-bold text-[#0B1220] mb-4" data-id="element-42">
            Brands We Distribute
          </h2>
          <p className="text-lg text-gray-600" data-id="element-43">
            Authorized partnerships with leading security hardware manufacturers
          </p>
        </motion.div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-44">
          {brands.map((brand, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all border border-gray-100 group cursor-pointer" data-id="element-45">
              <div className="text-center" data-id="element-46">
                <div className={`w-20 h-20 mx-auto mb-4 bg-gradient-to-br ${brand.color} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-47">
                  {brand.customLogo ? <img src={brand.customLogo} alt={`${brand.name} logo`} className="w-12 h-12 object-contain" data-id="element-48" /> : <brand.icon className="w-10 h-10 text-white" data-id="element-49" />}
                </div>
                <p className="text-base font-bold text-[#0B1220] mb-1" data-id="element-50">
                  {brand.name}
                </p>
                <p className="text-xs text-gray-500" data-id="element-51">{brand.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}